export default __webpack_public_path__ + "static/media/o2.b629d4ca.jpg";